import { styled } from '@mui/material';
import React from 'react';
import { getEntityImage } from '../../../utils/assetUtils.js';

var IconGroupContainer = styled('div')({
    '*': {
        mixBlendMode: 'unset !important',
    },
    '.hidden-counts': {
        marginLeft: 7,
        fontWeight: 600,
    },
    '.logos': {
        display: 'flex',
        alignItems: 'center',
    },
    display: 'flex',
    alignItems: 'center',
});
var RetailerIconGroup = function (_a) {
    var retailerIds = _a.retailerIds, _b = _a.maxSize, maxSize = _b === void 0 ? 4 : _b, _c = _a.iconSize, iconSize = _c === void 0 ? 18 : _c, _d = _a.buildUnrenderedIconCountString, buildUnrenderedIconCountString = _d === void 0 ? function (hiddenIconCount) { return "+".concat(hiddenIconCount); } : _d;
    var retailerIdsToRender = retailerIds.slice(0, maxSize);
    var hiddenIconCount = retailerIds.length - maxSize;
    return (React.createElement(IconGroupContainer, { style: {} },
        React.createElement("div", { className: "logos", style: {
                width: retailerIdsToRender.length * iconSize - iconSize * 0.46 * (retailerIdsToRender.length - 1),
            } }, retailerIdsToRender.map(function (retailerId, index) {
            var shiftOffset = iconSize * 0.46;
            return (React.createElement("img", { key: "retailer-logo-".concat(retailerId), src: getEntityImage(retailerId, 'retailer'), alt: "retailer-logo", style: {
                    width: iconSize,
                    height: iconSize,
                    objectFit: 'contain',
                    borderRadius: 999,
                    fontSize: 10,
                    position: 'relative',
                    left: -shiftOffset * index,
                    zIndex: retailerIdsToRender.length - index,
                } }));
        })),
        hiddenIconCount >= 1 ? (React.createElement("div", { className: "hidden-counts", style: { fontSize: 11 } }, buildUnrenderedIconCountString(hiddenIconCount))) : null));
};

export { RetailerIconGroup };
//# sourceMappingURL=index.js.map
